import React from 'react';
import { motion } from 'framer-motion';
import RobotIcon from './RobotIcon';

const ChatButton = ({ isOpen, onClick }) => {
  if (isOpen) return null;

  return (
    <motion.button
      className="chat-fab"
      onClick={onClick}
      whileTap={{ scale: 0.92 }}
      aria-label="Seyahat Asistani"
    >
      <RobotIcon size={66} />
    </motion.button>
  );
};

export default ChatButton;
